import apiClient from "../../api/api";

/**
 * Sends a request to create a new applicant account.
 *
 * @async
 * @function requestCreateApplicant
 * @param {Object} applicant - Applicant registration data.
 * @param {string} applicant.firstName - Applicant first name.
 * @param {string} applicant.lastName - Applicant last name.
 * @param {string} applicant.email - Applicant email address.
 * @param {string} applicant.password - Applicant password.
 * @param {string} applicant.phone - Applicant phone number.
 * @param {string} applicant.address - Applicant address.
 * @param {string} applicant.city - Applicant city.
 * @param {number} applicant.roleName - Applicant role (usually 7).
 * @param {string} [applicant.recaptchaToken] - Google reCAPTCHA v3 token.
 *
 * @returns {Promise<void>} Resolves when the applicant is successfully created.
 *
 * @throws Will throw an error if the API request fails.
 */
export const requestCreateApplicant = async(applicant) => {
    const response = await apiClient.post(import.meta.env.VITE_APPLICANTS_BASE_URL, applicant, {successToast: "Account created successfully"})

    return response.data
}

export const requestUpdateApplicant = async(applicantId, updatedData) => {
    const response = await apiClient.patch(`${import.meta.env.VITE_APPLICANTS_BASE_URL}/${applicantId}`, updatedData, {successToast: "Personal information updated successfully"})

    return response.data
}